export const RESOURCE_URLS = {
  PRODUCT_QUERIES: 'https://unhabonita.com.br/guia-primecuticle/',
  ORDER_QUERIES: 'https://store.ubbeauty.com.br/acompanhando-seu-pedido/ ',
  TIP_QUERIES: 'https://www.ubbeauty.com.br/store/cuidados-com-a-ponta',
  PRODUCT_COMPOSITION: 'https://ubbeauty.com.br/produtos/',
  CANCELLED_TRANSACTION: 'https://www.ubbeauty.com.br/store/transac-o-cancelada-motivos',
  DELIVERY: 'https://www.ubbeauty.com.br/store/entrega/',
  RETURNS: 'https://www.ubbeauty.com.br/store/trocas-devolucoes/',
  TRACKING: 'https://www.ubbeauty.com.br/store/acompanhando-seu-pedido/',
  LOOSE_TIP: 'https://store.ubbeauty.com.br/cuidados-com-a-ponta/',
}